// extracted by mini-css-extract-plugin
export default {"flex":"_13OHpFIB","slide":"_1u67jLhO","nonInteractive":"_3X7yDO_4"};